
export const environment = {
  production: false,
  serviceUrl: '/backend-erp/',
  serviceUrlLogin: '/backend-login/',
  serviceUrl_Report: '/backend-report/',
  serviceUrl_Adjuntos: '/backend-adjuntos/',
  serviceUrl_FE: '/backend-fe/',

  TSI_CONFIGURACION: 'url_configuracion',
  TSI_CONFIGURACION_PRUEBA: 'url_configuracion',
  TSI_PLANILLA: 'url_planilla',
  TSI_PLANILLA_PRUEBA: 'url_planilla',
  TSI_MODIFICACIONES: 'url_modificaciones',
  TSI_MODIFICACIONES_PRUEBA: 'url_modificaciones',
  TSI_CRM: 'url_crm',
  TSI_CRM_PRUEBA: 'url_crm',
  TSI_CONTROL_ASISTENCIA: 'url_control_asistencia',
  TSI_CONTROL_ASISTENCIA_PRUEBA: 'url_control_asistencia',
  TSI_CONTROL_VERSIONES: 'url_control_versiones',
  TSI_CONTROL_VERSIONES_PRUEBA: 'url_control_versiones',
  TSI_LAVANDERIA: 'url_lavanderia',
  TSI_LAVANDERIA_PRUEBA: 'url_lavanderia',
  TSI_DECLARACIONES_TRIBUTOS: 'url_declaraciones_tributos',
  TSI_DECLARACIONES_TRIBUTOS_PRUEBA: 'url_declaraciones_tributos',
  recaptcha: {
    siteKey: '6LdqZT0sAAAAAHAFBX8eo0fXQKCHYhd9C6IoY7UZ',
  },
};